import { CommandProps, Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { BlockTypes, EmbedLinkBlockData } from '../../../../models';
import { EmbedLinkNodeView } from './EmbedLinkNodeView';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    embedLinkNode: { insertEmbedLinkNode: ({ link }: EmbedLinkBlockData) => ReturnType };
  }
}

export const EmbedLinkNode = Node.create({
  name: 'embedLinkNode',
  group: 'block',
  atom: true,

  addAttributes() {
    return { link: null };
  },

  parseHTML() {
    return [{ tag: BlockTypes.embedlink }];
  },

  renderHTML({ HTMLAttributes }) {
    return [BlockTypes.embedlink, mergeAttributes(HTMLAttributes)];
  },

  addCommands() {
    return {
      insertEmbedLinkNode:
        ({ link }: EmbedLinkBlockData) =>
        ({ commands }: CommandProps) => {
          return commands.insertContent({ type: this.name, attrs: { link } });
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(EmbedLinkNodeView);
  },
});
